import type { MenuItem } from './charity-menu';

export const userMenuItems: MenuItem[] = [
  {
    id: 'dashboard',
    label: 'Donations',
    href: '/dashboard',
    icon: 'M0.391357 9.43491C-0.738297 5.88202 0.582966 1.46479 4.28566 0.264231C6.23334 -0.368924 8.63688 0.159235 10.0024 2.05658C11.2899 0.0892382 13.763 -0.364682 15.7085 0.264231C19.4102 1.46479 20.7388 5.88202 19.6102 9.43491C17.852 15.0665 11.7174 18 10.0024 18C8.2884 18 2.20849 15.1322 0.391357 9.43491Z'
  },
  {
    id: 'my-employers',
    label: 'My Employers',
    href: '/my-employers',
    icon: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z'
  },
  {
    id: 'charities',
    label: 'Charities',
    href: '/charities',
    icon: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
  },
]; 